export default "__VITE_ASSET__ac059298__"